// visionConfig created using env-config.js for use during `yarn serve`
type VisionConfig = Record<string, string>
type VisionConfigWindow = Window & { visionConfig?: VisionConfig }

const visionConfigFromWindow = (window as VisionConfigWindow).visionConfig
const visionConfig: VisionConfig = typeof visionConfigFromWindow !== 'object' ? {} : visionConfigFromWindow
const env: Record<string, string> = Object.assign({}, process.env, visionConfig)

const config = {
  auth0: {
    callbackUrl: env.REACT_APP_AUTH0_CALLBACK ?? 'http://localhost:3001/login',
    clientId: env.REACT_APP_AUTH0_CLIENT ?? 'N6ezr5rYUQdiikP1CP4SXPVO8emy7tsn',
    domain: env.REACT_APP_AUTH0_DOMAIN ?? 'truepill-dev.us.auth0.com',
  },
  dataDog: {
    applicationId: env.REACT_APP_DD_APP_ID || '',
    clientToken: env.REACT_APP_DD_TOKEN || '',
    env: env.REACT_APP_DD_ENV || 'local',
    service: env.REACT_APP_DD_SERVICE || 'vision-app',
    version: env.REACT_APP_GITHUB_COMMIT || undefined,
  },
  launchDarkly: {
    clientSideID: env.REACT_APP_LAUNCH_DARKLY_CLIENT_SIDE_ID ?? '631f5e84cc6fc7115d584143', // default to tpos Development environment
  },
  mixpanel: {
    projectToken: env.REACT_APP_MIXPANEL_PROJECT_TOKEN ?? '', // default to empty string to avoid bloating events when developing locally
  },
}

export default config
